import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import Footer from '../components/Footer/Footer';
import ProjectDetails from '../components/ProjectDetails/ProjectDetails';

export class ProjectDetailsPage extends Component {

  componentDidMount(){
    window.scroll(0,0);
  }



  render() {
    return (
     <Fragment>
        <TopNavigation></TopNavigation>
        <PageTop pageTitle="Event Details"></PageTop>
        <ProjectDetails></ProjectDetails>
        
        <Footer></Footer>
     </Fragment>
    )
  }
}

export default ProjectDetailsPage
